/**
 * Default joy control mapping — mirrors the hardcoded bindings in
 * JoyKeyboardTopicCommander and JoystickController.
 *
 * Used as:
 *  - Fallback when a robot type has no joy_control_mapping assigned.
 *  - "Reset to defaults" seed in the JoyControlMappings admin editor.
 */
const DEFAULT_JOY_CONTROL_MAPPING = {
  name: "Default",
  description: "Standard keyboard and gamepad bindings",
  axes_count: 6,
  buttons_count: 16,

  // --- Keyboard bindings ---
  // Each entry: { key, type: "axis"|"button", index, value }
  keyboard_bindings: [
    // Left stick: A/D → axis 0, W/S → axis 1
    { key: "KeyA", type: "axis", index: 0, value: -1 },
    { key: "KeyD", type: "axis", index: 0, value: 1 },
    { key: "KeyW", type: "axis", index: 1, value: -1 },
    { key: "KeyS", type: "axis", index: 1, value: 1 },
    // Right stick: J/L → axis 2, I/K → axis 3
    { key: "KeyJ", type: "axis", index: 2, value: -1 },
    { key: "KeyL", type: "axis", index: 2, value: 1 },
    { key: "KeyI", type: "axis", index: 3, value: -1 },
    { key: "KeyK", type: "axis", index: 3, value: 1 },
    // Triggers
    { key: "Digit1", type: "axis", index: 4, value: 1 },
    { key: "Digit3", type: "axis", index: 5, value: 1 },
    // Buttons
    { key: "Space",      type: "button", index: 0,  value: 1 }, // A
    { key: "KeyE",       type: "button", index: 1,  value: 1 }, // B
    { key: "KeyQ",       type: "button", index: 2,  value: 1 }, // X
    { key: "KeyR",       type: "button", index: 3,  value: 1 }, // Y
    { key: "KeyZ",       type: "button", index: 4,  value: 1 }, // LB
    { key: "KeyC",       type: "button", index: 5,  value: 1 }, // RB
    { key: "Digit1",     type: "button", index: 6,  value: 1 }, // L2 (also axis 4)
    { key: "Digit3",     type: "button", index: 7,  value: 1 }, // R2 (also axis 5)
    { key: "Digit6",     type: "button", index: 8,  value: 1 }, // Select
    { key: "Digit7",     type: "button", index: 9,  value: 1 }, // Start
    { key: "Digit9",     type: "button", index: 10, value: 1 }, // L3
    { key: "Digit0",     type: "button", index: 11, value: 1 }, // R3
    { key: "ArrowUp",    type: "button", index: 12, value: 1 },
    { key: "ArrowDown",  type: "button", index: 13, value: 1 },
    { key: "ArrowLeft",  type: "button", index: 14, value: 1 },
    { key: "ArrowRight", type: "button", index: 15, value: 1 },
  ],

  // --- Physical/virtual gamepad axis bindings ---
  // Each entry: { gamepad_axis_index, joy_axis_index, scale }
  // Identity mapping: gamepad axis N → joy axis N (scale 1.0)
  gamepad_axis_bindings: [
    { gamepad_axis_index: 0, joy_axis_index: 0, scale: 1.0 },
    { gamepad_axis_index: 1, joy_axis_index: 1, scale: 1.0 },
    { gamepad_axis_index: 2, joy_axis_index: 2, scale: 1.0 },
    { gamepad_axis_index: 3, joy_axis_index: 3, scale: 1.0 },
  ],

  // --- Physical/virtual gamepad button bindings ---
  // Each entry: { gamepad_button_index, joy_button_index }
  // Identity mapping: gamepad button N → joy button N
  gamepad_button_bindings: Array.from({ length: 16 }, (_, i) => ({
    gamepad_button_index: i,
    joy_button_index: i,
  })),
};

export default DEFAULT_JOY_CONTROL_MAPPING;
